import { apiFetch } from "../../api/apiFetch";
import { getUserId } from "../../api/session";
export async function setForgottenPassword(id, pwd) {
    const req = { RequestID: id, NewPassword: pwd };
    const response = await apiFetch('account/setforgottenpassword', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}
export async function setPassword(old, newp) {
    const req = { OldPassword: old, NewPassword: newp };
    const response = await apiFetch('account/setpassword', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}
export async function getPasswordResetRequest(id) {
    let url = 'account/getpasswordresetrequest?id=' + id;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}
export async function createPasswordResetRequest(email) {
    const req = { Email: email};
    const response = await apiFetch('account/createpasswordresetrequest', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}
export async function disableAccount(id) {
    const req = { UserID: id };
    const response = await apiFetch('account/disableaccount', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}
export async function deleteAccount(id) {
    const req = { UserID: id };
    const response = await apiFetch('account/deleteaccount', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return false;
}
export async function setPublic(attr) {

    const userid = getUserId();
    const req = { UserID: userid, Attribute: attr };
    const response = await apiFetch('profile/setpublic', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) {
        return await response.json();
    }
    return null;
}

export async function removePublic(attr) {

    const userid = getUserId();
    const req = { UserID: userid, Attribute: attr };
    const response = await apiFetch('profile/removepublic', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) {
        return await response.json();
    }
    return null;
}


export async function isOnline(userid) {
    let url = 'account/isonline?userid=' + userid;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return false;
    const data = await response.json();
    if (data)
        return data;
    return false;
}
export async function getUserProfile(appid) {

    // NOTE: API expects userid, not appid. We keep the signature to avoid refactor churn.
    const userid = getUserId();
    const response = await apiFetch('profile/getfullprofile?userid=' + userid);
    if (response.status !== 200)
        return 'error';
    const data = await response.json();
    return data ?? null;
}

export async function getPublicAttributes() {

    const userid = getUserId();
    const response = await apiFetch('profile/getpublicattributes?userid=' + userid);
    if (response.status !== 200)
        return 'error';
    const data = await response.json();
    return data ?? null;
}

export async function getUserInfo(appid) {
    let url = 'account/user?appid=' + appid;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}

export async function getUserAvatar(userid) {

    const response = await apiFetch('account/getuseravatar?userid=' + userid);
    if (response.status !== 200)
        return 'error';
    const data = await response.json();
    return data ?? null;
}


export async function getUserTheme() {

    // Theme was previously stored in the retired BFF. Keep it purely client-side now.
    return localStorage.getItem('theme') || '';
}


export async function setUserTheme(theme) {

    localStorage.setItem('theme', theme || '');
    return true;
}


export async function getProfileImage(userid) {

    const id = userid || getUserId();
    const response = await apiFetch('accountprofile/userprofileimage?userid=' + id);
    if (response.status !== 200)
        return 'error';
    const data = await response.json();
    return data ?? null;
}


export async function removeStrength(id) {

    const response = await apiFetch('profile/deletestrength?id=' + id, { method: 'POST' });
    if (response.status === 200) return await response.json();
    return null;
}


export async function addStrength(strength) {

    const userid = getUserId();
    const req = { UserID: userid, IsStrength: true, Type: strength, Rank: 0, Impacts: '' };
    const response = await apiFetch('profile/addstrength', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function removeWeakness(id) {

    const response = await apiFetch('profile/deleteweakness?id=' + id, { method: 'POST' });
    if (response.status === 200) return await response.json();
    return null;
}


export async function addWeakness(strength) {

    const userid = getUserId();
    const req = { UserID: userid, IsStrength: false, Type: strength, Rank: 0, Impacts: '' };
    const response = await apiFetch('profile/addweakness', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function saveName(first, middle, last) {

    const userid = getUserId();
    const req = { UserID: userid, FirstName: first, MiddleName: middle, LastName: last };
    const response = await apiFetch('accountprofile/setname', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function saveHeadline(headline) {

    const userid = getUserId();
    const req = { UserID: userid, Headline: headline };
    const response = await apiFetch('profile/updateheadline', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function saveImportantDate(type, date) {

    const userid = getUserId();
    const req = { UserID: userid, DateType: type, Value: date };
    const response = await apiFetch('profile/setimportantdate', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function saveTrait(type, val) {

    const userid = getUserId();
    const req = { UserID: userid, Type: type, Value: val };
    const response = await apiFetch('profile/updatetrait', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function addAddress(type, street, city, state, zip, country, primary) {

    const userid = getUserId();
    const req = { UserID: userid, Type: type, Street: street, City: city, State: state, Zip: zip, Country: country, IsPrimary: primary };
    const response = await apiFetch('profile/addaddress', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function editAddress(id, type, street, city, state, zip, country, primary) {

    const req = { AddressID: id, Type: type, Street: street, City: city, State: state, Zip: zip, Country: country, IsPrimary: primary };
    const response = await apiFetch('profile/editaddress', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function deleteEmail(id) {

    const response = await apiFetch('profile/deleteemail?id=' + id, { method: 'POST' });
    if (response.status === 200) return await response.json();
    return null;
}


export async function deletePhone(id) {

    const response = await apiFetch('profile/deletephone?id=' + id, { method: 'POST' });
    if (response.status === 200) return await response.json();
    return null;
}


export async function deleteAddress(id) {

    const response = await apiFetch('profile/deleteaddress?id=' + id, { method: 'POST' });
    if (response.status === 200) return await response.json();
    return null;
}


export async function deleteFamily(id) {

    const response = await apiFetch('profile/deletefamilymember?id=' + id, { method: 'POST' });
    if (response.status === 200) return await response.json();
    return null;
}


export async function addEmail(type, email, primary) {

    const userid = getUserId();
    const req = { UserID: userid, Type: type, Email: email, IsPrimary: primary };
    const response = await apiFetch('profile/addemail', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function editEmail(id, type, email, primary) {

    const req = { EmailID: id, Type: type, Email: email, IsPrimary: primary };
    const response = await apiFetch('profile/editemail', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function addPhone(type, number, primary) {

    const userid = getUserId();
    const req = { UserID: userid, Type: type, Number: number, IsPrimary: primary };
    const response = await apiFetch('profile/addphone', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function editPhone(id, type, number, primary) {

    const req = { PhoneID: id, Type: type, Number: number, IsPrimary: primary };
    const response = await apiFetch('profile/editphone', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function addFamily(first, middle, last, gender, type, dob) {

    const userid = getUserId();
    const req = { UserID: userid, FirstName: first, MiddleName: middle, LastName: last, Gender: gender, Type: type, DOB: dob };
    const response = await apiFetch('profile/addfamilymember', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}


export async function editFamily(id, first, middle, last, gender, type, dob) {

    const req = { ID: id, FirstName: first, MiddleName: middle, LastName: last, Gender: gender, Type: type, DOB: dob };
    const response = await apiFetch('profile/editfamilymember', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}

export async function setSiteOptions(userid, photoid, showfollowbtn, showaboutbtn, showabout, showcontent, showposts, showfeatured, featuredtitle, featureddesc, featuredid, featuredtype, style, bio) {

    const req = {
        UserID: userid,
        ProfilePhotoID: photoid,
        ShowFollowButton: showfollowbtn,
        ShowAboutButton: showaboutbtn,
        ShowAboutSection: showabout,
        ShowContentSection: showcontent,
        ShowPostsSection: showposts,
        ShowFeaturedSection: showfeatured,
        FeaturedTitle: featuredtitle,
        FeaturedDesc: featureddesc,
        FeaturedID: featuredid,
        FeaturedType: featuredtype,
        Style: style,
        Bio: bio
    };

    const response = await apiFetch('profile/setsiteoptions', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}

export async function getSiteOptions(id) {
    let url = 'profile/getsiteoptions?id=' + id;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}
export async function getSiteContent(id) {
    let url = 'profile/getusersite?id=' + id;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}
export async function getUserSiteProfile(id) {
    let url = 'profile/getsitefullprofile?userid=' + id;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}
export async function getUserList() {
    let url = 'account/userlist?userid=' + getUserId();
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}
export async function followUser(userid, targetid) {

    const req = { UserID: userid, TargetID: targetid };
    const response = await apiFetch('account/followuser', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}

export async function unfollowUser(userid, targetid) {
    const req = { UserID: userid, TargetID: targetid };
    const response = await apiFetch('account/unfollowuser', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    })
    if (response.status === 200) {
        return await response.json();
    }
    return null;
}
export async function getUserFollowers() {
    let url = 'account/getuserfollowers?userid=' + getUserId();
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}
export async function getUsersFollowing() {
    let url = 'account/getusersfollowing?userid=' + getUserId();
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}
export async function setFeedPreferences(userid, politics, profanity, adult) {

    const req = { UserID: userid, Politics: politics, Profanity: profanity, AdultContent: adult };
    const response = await apiFetch('profile/setfeedpreferences', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
    });
    if (response.status === 200) return await response.json();
    return null;
}

export async function getFeedPreferences(id) {
    let url = 'profile/getfeedpreferences?id=' + id;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}